// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import EditOutlinedSvg from "@ant-design/icons-svg/lib/asn/EditOutlined";
import AntdIcon from "../components/AntdIcon";
const EditOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: EditOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    EditOutlined.displayName = "EditOutlined";
}
export default /*#__PURE__*/ React.forwardRef(EditOutlined);
